export const MAX_CONCURRENT_UPLOADS = 5;
export const FILES_LENTH_WARN = 30;
export const PAGE_LIMIT = 20;
export const MAX_FILES_TO_DISPLAY = 700;
export const UPLOADING_STATUS_TEXT = 'Uploading files';
export const UPLOAD_DONE_STATUS_TEXT = 'Upload done';
export const STATUS = {
  UPLOADING: 'UPLOADING',
  SILENT: 'SILENT'
}

